import * as THREE from 'three'

export default class House extends THREE.Object3D {
    constructor() {
        super();
        this.textureLoader = new THREE.TextureLoader();
        this._init();
    }

    _init() {
        this._createBushes();
        this._createDoor();
        this._createWalls();
        this._createRoof();
    }

    _createBushes() {
        const bushColorTexture = this.textureLoader.load('./assets/textures/bush/leaves_forest_ground_1k/leaves_forest_ground_diff_1k.webp')
        const bushARMTexture = this.textureLoader.load('./assets/textures/bush/leaves_forest_ground_1k/leaves_forest_ground_arm_1k.webp')
        const bushNormalTexture = this.textureLoader.load('./assets/textures/bush/leaves_forest_ground_1k/leaves_forest_ground_nor_gl_1k.webp')
        
        bushColorTexture.colorSpace = THREE.SRGBColorSpace
        
        bushColorTexture.repeat.set(3, 1)
        bushARMTexture.repeat.set(3, 1)
        bushNormalTexture.repeat.set(3, 1)
        
        bushColorTexture.wrapS = THREE.RepeatWrapping
        bushARMTexture.wrapS = THREE.RepeatWrapping
        bushNormalTexture.wrapS = THREE.RepeatWrapping

        const bushGeometry = new THREE.SphereGeometry(1, 16, 16)
        const bushMaterial = new THREE.MeshStandardMaterial({
            color: '#ccffcc',
            map: bushColorTexture,
            aoMap: bushARMTexture,
            roughnessMap: bushARMTexture,
            metalnessMap: bushARMTexture,
            normalMap: bushNormalTexture
        })

        const bush1 = new THREE.Mesh(bushGeometry, bushMaterial)
        bush1.scale.set(0.5, 0.5, 0.5)
        bush1.position.set(0.8, 0.2, 2.2)
        bush1.rotation.x = -0.75

        const bush2 = new THREE.Mesh(bushGeometry, bushMaterial)
        bush2.scale.set(0.25, 0.25, 0.25)
        bush2.position.set(1.4, 0.1, 2.1)
        bush2.rotation.x = -0.75

        const bush3 = new THREE.Mesh(bushGeometry, bushMaterial)
        bush3.scale.set(0.4, 0.4, 0.4)
        bush3.position.set(-0.8, 0.1, 2.3)
        bush3.rotation.x = -0.75

        const bush4 = new THREE.Mesh(bushGeometry, bushMaterial)
        bush4.scale.set(0.15, 0.15, 0.15)
        bush4.position.set(-1, 0.05, 2.6)
        bush4.rotation.x = -0.75

        this.add(bush1, bush2, bush3, bush4)
    }

    _createDoor() {
        const doorColorTexture = this.textureLoader.load('./assets/textures/door/color.webp')
        const doorAlphaTexture = this.textureLoader.load('./assets/textures/door/alpha.webp')
        const doorAmbientOcclusionTexture = this.textureLoader.load('./assets/textures/door/ambientOcclusion.webp')
        const doorHeightTexture = this.textureLoader.load('./assets/textures/door/height.webp')
        const doorNormalTexture = this.textureLoader.load('./assets/textures/door/normal.webp')
        const doorMetalnessTexture = this.textureLoader.load('./assets/textures/door/metalness.webp')
        const doorRoughnessTexture = this.textureLoader.load('./assets/textures/door/roughness.webp')
        
        doorColorTexture.colorSpace = THREE.SRGBColorSpace

        const door = new THREE.Mesh(
            new THREE.PlaneGeometry(2.2, 2.2, 100, 100),
            new THREE.MeshStandardMaterial({
                map: doorColorTexture,
                alphaMap: doorAlphaTexture,
                transparent: true,
                aoMap: doorAmbientOcclusionTexture,
                roughnessMap: doorRoughnessTexture,
                metalnessMap: doorMetalnessTexture,
                normalMap: doorNormalTexture,
                displacementMap: doorHeightTexture,
                displacementScale: 0.15,
                displacementBias: -0.04
            })
        )
        door.position.z = 2 + 0.01
        door.position.y = 1
        this.add(door)
    }

    _createWalls() {
        const wallColorTexture = this.textureLoader.load('./assets/textures/wall/stone_wall_04_1k/stone_wall_04_diff_1k.webp')
        const wallARMTexture = this.textureLoader.load('./assets/textures/wall/stone_wall_04_1k/stone_wall_04_arm_1k.webp')
        const wallNormalTexture = this.textureLoader.load('./assets/textures/wall/stone_wall_04_1k/stone_wall_04_nor_gl_1k.webp')

        wallColorTexture.colorSpace = THREE.SRGBColorSpace

        const walls = new THREE.Mesh(
            new THREE.BoxGeometry(4, 2.5, 4),
            new THREE.MeshStandardMaterial({
                map: wallColorTexture,
                aoMap: wallARMTexture,
                roughnessMap: wallARMTexture,
                metalnessMap: wallARMTexture,
                normalMap: wallNormalTexture
            })
        )
        walls.translateY(1.25)
        walls.castShadow = true
        walls.receiveShadow = true
        this.add(walls)
    }

    _createRoof() {
        const roofColorTexture = this.textureLoader.load('./assets/textures/roof/clay_roof_tiles_1k/clay_roof_tiles_02_diff_1k.webp')
        const roofARMTexture = this.textureLoader.load('./assets/textures/roof/clay_roof_tiles_1k/clay_roof_tiles_02_arm_1k.webp')
        const roofNormalTexture = this.textureLoader.load('./assets/textures/roof/clay_roof_tiles_1k/clay_roof_tiles_02_nor_gl_1k.webp')
        
        roofColorTexture.colorSpace = THREE.SRGBColorSpace
        
        roofColorTexture.repeat.set(6, 1)
        roofARMTexture.repeat.set(6, 1)
        roofNormalTexture.repeat.set(6, 1)
        
        roofColorTexture.wrapS = THREE.RepeatWrapping
        roofARMTexture.wrapS = THREE.RepeatWrapping
        roofNormalTexture.wrapS = THREE.RepeatWrapping

        const roof = new THREE.Mesh(
            new THREE.ConeGeometry(3.5, 1.5, 4),
            new THREE.MeshStandardMaterial({
                map: roofColorTexture,
                aoMap: roofARMTexture,
                roughnessMap: roofARMTexture,
                metalnessMap: roofARMTexture,
                normalMap: roofNormalTexture
            })
        )
        roof.position.y = 2.5 + 0.75
        roof.rotation.y = Math.PI * 0.25
        roof.castShadow = true
        this.add(roof)
    }
}